import { render } from "./FilterDistrikSidigi.vue?vue&type=template&id=158f0030"
import script from "./FilterDistrikSidigi.vue?vue&type=script&lang=js"
export * from "./FilterDistrikSidigi.vue?vue&type=script&lang=js"
script.render = render

export default script